<template>
    <div>
        <hb-blade-header half class="task-center-header" @close="close(true)" :back-button-off="true">

            <template v-if="!$vuetify.breakpoint.xs">
                <help-juice blade-header />
            </template>
            <template v-slot:title>
                <div class="d-flex align-center">
                    <hb-icon color="#101318" :customSize="28" class="mr-2">mdi-playlist-check</hb-icon> Task Center
                </div>
            </template>
        </hb-blade-header>
        <div class="pad-10px">
            <div class="d-flex justify-space-between px-4 align-end">
                <div class="task-filters">
                    <hb-autocomplete rounded v-model="selectedFilter" item-text="name" item-value="id" @change="getTasksAndCountEvent(true)" :items="filtersList" placeholder="Select Type"
                        :clearable="false" width="244px" return-object style="display:inline-block">
                    </hb-autocomplete>
                </div>
                <div class="task-btns">
                    <hb-icon class="task-btn-icon hand" @click="createTaskShowDialogEvent">mdi-plus</hb-icon>
                    <!-- <hb-icon class="task-btn-icon hand" @click="showFilterDialog = true">mdi-tune</hb-icon> -->
                    <div class="filter-icon task-btn-icon hand" :class="{'active-filter': filtersCount ? true : false}" @click="showFilterDialog = true">
                        <span class="filter-count" v-if="filtersCount">{{ filtersCount }}</span>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <mask id="mask0_3051_193812" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0"
                                width="24" height="24">
                                <rect width="24" height="24" fill="#D9D9D9" />
                            </mask>
                            <g mask="url(#mask0_3051_193812)">
                                <path
                                    d="M17.75 20.25C16.7 20.25 15.8125 19.8875 15.0875 19.1625C14.3625 18.4375 14 17.55 14 16.5C14 15.45 14.3625 14.5625 15.0875 13.8375C15.8125 13.1125 16.7 12.75 17.75 12.75C18.8 12.75 19.6875 13.1125 20.4125 13.8375C21.1375 14.5625 21.5 15.45 21.5 16.5C21.5 17.55 21.1375 18.4375 20.4125 19.1625C19.6875 19.8875 18.8 20.25 17.75 20.25ZM17.75 18.25C18.2333 18.25 18.6458 18.0792 18.9875 17.7375C19.3292 17.3958 19.5 16.9833 19.5 16.5C19.5 16.0167 19.3292 15.6042 18.9875 15.2625C18.6458 14.9208 18.2333 14.75 17.75 14.75C17.2667 14.75 16.8542 14.9208 16.5125 15.2625C16.1708 15.6042 16 16.0167 16 16.5C16 16.9833 16.1708 17.3958 16.5125 17.7375C16.8542 18.0792 17.2667 18.25 17.75 18.25ZM4 17.5V15.5H12V17.5H4ZM6.25 11.25C5.2 11.25 4.3125 10.8875 3.5875 10.1625C2.8625 9.4375 2.5 8.55 2.5 7.5C2.5 6.45 2.8625 5.5625 3.5875 4.8375C4.3125 4.1125 5.2 3.75 6.25 3.75C7.3 3.75 8.1875 4.1125 8.9125 4.8375C9.6375 5.5625 10 6.45 10 7.5C10 8.55 9.6375 9.4375 8.9125 10.1625C8.1875 10.8875 7.3 11.25 6.25 11.25ZM6.25 9.25C6.73333 9.25 7.14583 9.07917 7.4875 8.7375C7.82917 8.39583 8 7.98333 8 7.5C8 7.01667 7.82917 6.60417 7.4875 6.2625C7.14583 5.92083 6.73333 5.75 6.25 5.75C5.76667 5.75 5.35417 5.92083 5.0125 6.2625C4.67083 6.60417 4.5 7.01667 4.5 7.5C4.5 7.98333 4.67083 8.39583 5.0125 8.7375C5.35417 9.07917 5.76667 9.25 6.25 9.25ZM12 8.5V6.5H20V8.5H12Z"
                                    fill="#637381" />
                            </g>
                        </svg>

                    </div>
                    <!-- <hb-icon class="task-btn-icon">mdi-dots-vertical</hb-icon> -->
                </div>
            </div>
            <div class="d-flex justify-space-between pt-4 px-4">
                <v-menu offset-y v-for="(item, index) in taskBuckets" :key="index">
                    <template v-slot:activator="{ on, attrs }">
                        <div v-bind="attrs" v-on="on" class="task-bucket" @click="clickedMenu(index)"
                            :class="{ 'bucket-active': index === activeMenu }">
                            <div class="bucket-icon">
                                <hb-icon color="#101318">{{ item.icon }}</hb-icon>
                                <div class="tasks-counter d-flex" v-if="getBucketCount(item)"><span class="d-flex" v-if="getBucketCount(item, true)"><HbIcon small :custom-size="12" style="position: relative; top: 1px" color="#ffffff" mdi-code="mdi-custom-hot-task" /> {{ getBucketCount(item, true) }}/</span>{{ getBucketCount(item) }}</div>
                            </div>
                            <p class="hb-font-caption-medium mb-0">{{ item.title }}</p>
                        </div>
                    </template>
                    <v-list v-if="taskTypes && Object.keys(taskTypes).length" style="max-height: 300px; overflow: auto;">
                        <v-list-item v-for="i in taskTypes[item.value]" :ripple="false"
                            @click="showFiltered({ parent: item, child: i })">
                            <v-list-item-title class="pr-8" :style="{'max-width': getTypeCount(i, item.value) ? '250px' : '' }">{{ i.name }} 
                                <span v-if="getTypeCount(i, item.value)" class="menu-task-count">
                                    {{ getTypeCount(i, item.value) }}
                                </span>
                            </v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </div>

            <div class="d-flex justify-space-between pt-4 px-4" v-if="activeFilter">
                <div class="filter-title">
                    <hb-icon v-if="activeFilter.icon">{{ activeFilter.icon }}</hb-icon>
                    <p class="hb-font-body-medium mb-0 ml-2">{{ activeFilter.title }}</p>
                    <div class="tasks-counter-filter ml-2" v-if="activeFilter.count">{{ activeFilter.count }}</div>
                </div>
                <div class="clear-filter-btn hand" @click="clearFilterEvent">
                    <span class="mr-1 hb-font-caption-medium">clear</span>
                    <hb-icon small>mdi-close-circle</hb-icon>
                </div>
            </div>

            <div @scroll.self="fetchOnScroll" class="tasks-list mt-4 px-4" :style="{ maxHeight: tasksListheight, overflowY: 'auto' }">
                <hb-task v-for="item in tasksList" 
                    class="mb-3" 
                    :type="item.type"
                    :hot-task="item.hotTask"
                    :icon="item.icon | getIcon"
                    :title="item.title"
                    :time="item.time | formatDateServices"
                    :assigned-to="item.assignedTo"
                    :created-by="item.createdBy" 
                    :created-by-time="item.createdByTime | formatLocalDateTimeServices"
                    :completed-by="item.completedBy ? item.completedBy : ''"
                    :completed-by-time="item.completedByTime | formatLocalDateTimeServices" 
                    :updated-by="item.updatedBy" 
                    :updated-by-time="item.updatedByTime | formatLocalDateTimeServices"
                    :attachments="item.attachments ? item.attachments : ''" 
                    :space="item.space"
                    :spaceType="item.space ? item.spaceType : ''"
                    :expanded.sync="item.expanded"
                    :contact-name="item.contactName" 
                    :contact-status="item.contactStatus"
                    :contact-is-business="item.contactIsBusiness"
                    :property="item.property" 
                    :button-one="['completed','dismissed'].indexOf(item.status) == -1 && !item.isAutomated ? 'Update' : ''"
                    :button-two="['completed','dismissed'].indexOf(item.status) == -1 && item.isAutomated ? 'Reassign' : ''"
                    :button-one-loading="item.loadingBtnOne"
                    @button-one-click="updateTaskEvent(item)" 
                    :button-two-loading="item.loadingBtnTwo"
                    @button-two-click="updateTaskEvent(item, true)"
                    :status="item.labelStatus"
                    :timer-green-value="item.timerGreenValue"
                    :timer-red-value="item.timerRedValue"
                    :loading="item.showLoading"
                    @click="showDetailsEvent(item)">
                        {{ item.details }}
                </hb-task>

                <v-skeleton-loader
                    v-if="isFetchingTasks"
                    v-for="i in 3"
                    type="list-item-avatar, list-item-two-line"
                    class="mt-3"
                ></v-skeleton-loader>
            </div>


            <div class="empty-complete" v-if="!isFetchingTasks && !tasksList.length && !hasError">
                <span v-if="filtersCount">
                    <div class="filter-no-record">
                        <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <mask id="mask0_3081_235068" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="100" height="100">
                                <rect width="100" height="100" fill="#D9D9D9"/>
                            </mask>
                            <g mask="url(#mask0_3081_235068)">
                                <path d="M73.9557 84.375C69.5807 84.375 65.8828 82.8646 62.862 79.8437C59.8411 76.8229 58.3307 73.125 58.3307 68.75C58.3307 64.375 59.8411 60.6771 62.862 57.6563C65.8828 54.6354 69.5807 53.125 73.9557 53.125C78.3307 53.125 82.0286 54.6354 85.0495 57.6563C88.0703 60.6771 89.5807 64.375 89.5807 68.75C89.5807 73.125 88.0703 76.8229 85.0495 79.8437C82.0286 82.8646 78.3307 84.375 73.9557 84.375ZM73.9557 76.0417C75.9696 76.0417 77.6884 75.3299 79.112 73.9062C80.5356 72.4826 81.2474 70.7639 81.2474 68.75C81.2474 66.7361 80.5356 65.0174 79.112 63.5937C77.6884 62.1701 75.9696 61.4583 73.9557 61.4583C71.9418 61.4583 70.2231 62.1701 68.7995 63.5937C67.3759 65.0174 66.6641 66.7361 66.6641 68.75C66.6641 70.7639 67.3759 72.4826 68.7995 73.9062C70.2231 75.3299 71.9418 76.0417 73.9557 76.0417ZM16.6641 72.9167V64.5833H49.9974V72.9167H16.6641ZM26.0391 46.875C21.6641 46.875 17.9661 45.3646 14.9453 42.3437C11.9245 39.3229 10.4141 35.625 10.4141 31.25C10.4141 26.875 11.9245 23.1771 14.9453 20.1562C17.9661 17.1354 21.6641 15.625 26.0391 15.625C30.4141 15.625 34.112 17.1354 37.1328 20.1562C40.1536 23.1771 41.6641 26.875 41.6641 31.25C41.6641 35.625 40.1536 39.3229 37.1328 42.3437C34.112 45.3646 30.4141 46.875 26.0391 46.875ZM26.0391 38.5417C28.053 38.5417 29.7717 37.8299 31.1953 36.4063C32.6189 34.9826 33.3307 33.2639 33.3307 31.25C33.3307 29.2361 32.6189 27.5174 31.1953 26.0937C29.7717 24.6701 28.053 23.9583 26.0391 23.9583C24.0252 23.9583 22.3064 24.6701 20.8828 26.0937C19.4592 27.5174 18.7474 29.2361 18.7474 31.25C18.7474 33.2639 19.4592 34.9826 20.8828 36.4063C22.3064 37.8299 24.0252 38.5417 26.0391 38.5417ZM49.9974 35.4167V27.0833H83.3307V35.4167H49.9974Z" fill="#A5B4BF"/>
                            </g>
                        </svg>
                    </div>
                    <div class="complete-text">No Task Found!</div>
                    <hb-btn color="secondary" small @click="clearFiltersEvent">Clear filters</hb-btn>
                </span>
                <span v-else>
                    <hb-icon color="#A5B4BF" :customSize="100">mdi-emoticon-excited-outline</hb-icon>
                    <div class="complete-text">All task are completed!</div>
                </span>
            </div>
        </div>
        <create-task :task-sub-types="taskTypes" :task-assignees="taskAssignees" :fetch-tasks="getTasksAndCountEvent" v-if="showDialog" v-model="showDialog" :task-details="taskDetails" />
        <tasks-filter ref="filterModal" :setFilters="setFiltersEvent" :task-sub-types="taskTypes" :task-assignees="taskAssignees" :filtersData.sync="filtersData" v-model="showFilterDialog" />
        <update-system-task v-model="showAssignDialog" :fetch-tasks="getTasksAndCountEvent"  v-if="showAssignDialog" :task-assignees="taskAssignees" :task-details="taskDetails" />
        <task-details :task-details="singleTaskData" :fetch-tasks="getTasksAndCountEvent" :primaryRoleProperties="primaryRoleProperties" v-if="showDetailsDialog" v-model="showDetailsDialog" />
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import api from '../../../assets/api.js';
import moment from 'moment';
import { EventBus } from '../../../EventBus.js';
import { notificationMixin } from '../../../mixins/notificationMixin.js';

export default {
    name: "TaskCenter",
    mixins: [notificationMixin],
    data() {
        return {
            menuOption: [],
            activeMenu: '',
            pending: [],
            tempTask: [],
            urlEventIds: {},
            disableButtons: false,
            isLoaded: false,
            gTasksCount: '',
            filteredTasks: [],
            showFilters: false,
            showDismissModal: false,
            showCompleteAllModal: false,
            showDialog: false,
            showFilterDialog: false,
            filtersList: [
                {id: '', name: 'All Tasks'}, 
                {id: 'due_today', name: 'Due Today'}, 
                {id: 'overdue', name: 'Overdue'}, 
                {id: 'due_tomorrow', name: 'Due Tomorrow'}
            ],
            selectedFilter: {id: 'due_today', name: 'Due Today'},
            expanded: false,
            taskListsHeight: '100%',
            taskBuckets: [
                {
                    value: 'lead',
                    icon: 'mdi-account-plus',
                    title: 'Lead'
                },
                {
                    value: 'delinquency',
                    icon: 'mdi-shield-star',
                    title: 'Delinquency'
                },
                {
                    value: 'operations',
                    icon: 'mdi-settings',
                    title: 'Operations'
                },
                {
                    value: 'maintenance',
                    icon: 'mdi-tools',
                    title: 'Maintenance'
                }
            ],
            activeFilter: null,
            isSelected: false,
            showAssignDialog: false,
            showDetailsDialog: false,
            tasksList: [],
            taskTypes: {},
            taskDetails: null,
            taskAssignees: [],
            filtersCount: 0,
            isFetchingTasks: false,
            singleTaskData: null,
            isLoadingTask: false,
            countData: {
                lead: null,
                delinquency: null,
                operations: null,
                maintenance: null,
                other: null
            },
            intervalValue: null,
            hasError: false,
            isAllRecordsLoaded: false,
            filtersData: {}
        }
    },
    async created() {
        this.fetchAssignees();
        await this.fetchTaskTypes();
        this.getTasksAndCountEvent(true);
    },
    mounted() {
        document.addEventListener("click", this.handleClickOutside);
    },
    beforeDestroy() {
        document.removeEventListener("click", this.handleClickOutside);
    },
    computed: {
        ...mapGetters({
            primaryRoleProperties: 'propertiesStore/filtered'
        }),
        tasksListheight() {
            let filter = this.activeFilter
            let documentHeight = document.body.clientHeight;
            let heightValue = '100%';
            if(documentHeight) {
                heightValue = (((documentHeight - (315 + (filter ? 32 : 0))) / documentHeight) * 100).toFixed(2) + 'vh'
            }
            return heightValue;
        }
    },
    filters: {
        formatDateServices(value){
            if (!value || moment(value).format('MM/DD/YYYY') == 'Invalid date') return '';
            return moment(value).format('MMM DD, YYYY');
        },
        formatLocalDateTimeServices(value){
            if (!value) return '';
            return moment.utc(value).local().format('MMM DD, YYYY [@] h:mma');
        }
    },
    methods: {
        ...mapActions({
            markTask:  'taskCenterStore/markTask',
            setTaskCenterOpen: 'taskCenterStore/setTaskCenterOpen',
            actionFollowUpStatus:"onBoardingStore/actionFollowUpStatus",
            setTasksHotTotalCount: 'notificationsStore/setTasksHotTotalCount',
        }), 
        async fetchTaskTypes() {
            let response = await api.get(this, api.TASKS_CENTER + 'task_types');
            this.taskBuckets.forEach(item => {
                this.taskTypes[item.value] = response.task_types.filter(typeItem => typeItem.label === item.title).sort((a, b) => {
                    if (a.name === "Other") return 1;
                    if (b.name === "Other") return -1;
                    return a.name.localeCompare(b.name);
                });
                this.taskTypes[item.value].unshift({name: 'All Tasks', id: ''})
            });
        },

        async fetchTasksCount() {
            let filtersPayload = this.getFilters(true);
            let { tasks_counts } = await api.post(this, api.TASKS_CENTER + 'count', { filters: filtersPayload });
            this.countData = {
                lead: {
                    count: tasks_counts.labels_tasks_counts.find(item => item.task_type_label === "Lead"),
                    typesCount: tasks_counts.types_tasks_counts.filter(item => item.task_type_label === "Lead")
                },
                delinquency: {
                    count: tasks_counts.labels_tasks_counts.find(item => item.task_type_label === "Delinquency"),
                    typesCount: tasks_counts.types_tasks_counts.filter(item => item.task_type_label === "Delinquency")
                },
                operations: {
                    count: tasks_counts.labels_tasks_counts.find(item => item.task_type_label === "Operations"),
                    typesCount: tasks_counts.types_tasks_counts.filter(item => item.task_type_label === "Operations")
                },
                maintenance: {
                    count: tasks_counts.labels_tasks_counts.find(item => item.task_type_label === "Maintenance"),
                    typesCount: tasks_counts.types_tasks_counts.filter(item => item.task_type_label === "Maintenance")
                }
            }
            if (this.activeFilter) {
                this.activeFilter.count = this.getTypeCount({id: this.activeFilter.id, name: this.activeFilter.title}, this.activeFilter.parent);
            }
        },

        getTypeCount(task_type, bucket) {
            let type = !task_type.id && this.countData[bucket]?.count
            ? this.countData[bucket].count
            : this.countData[bucket]?.typesCount && this.countData[bucket].typesCount.find(item => item.task_type_id === task_type.id)
            ? this.countData[bucket].typesCount.find(item => item.task_type_id === task_type.id)
            : null
            return type ? type.all_tasks : 0
        },
        getBucketCount(bucket, isHot = false) {
            let count = this.countData[bucket.value]?.count ? isHot ?  this.countData[bucket.value]?.count?.hot_tasks : this.countData[bucket.value]?.count?.all_tasks : 0
            return count;
        },

        async fetchTasks(resetTasks = false, resetMainFilter = false) {
            try {
                this.hasError = false;
                this.isFetchingTasks = true;
                let filtersPayload = this.getFilters(false, resetTasks, resetMainFilter);
                let response = await api.post(this, api.TASKS_CENTER + 'all-tasks', filtersPayload);
                if(response.tasks.length) {
                    this.isAllRecordsLoaded = false;
                } else {
                    this.isAllRecordsLoaded = true;
                }
                this.tasksList = [...this.tasksList, ...response.tasks.map((item, index) => {
                    let association = '';
                    let assignees = '';
                    let property = '';
                    let attachments = [];
                    let contactData = null;
                    let meta_data = item.meta_data;
                    if (meta_data.Associations?.lease?.length) association = 'contact';
                    else if(meta_data.Associations?.space?.length) association = 'space';
                    else if(meta_data.Associations?.property?.length) association = 'property';
                    else association = undefined;
                    // if (association === 'space') {
                    //     meta_data.Associations.space[0].property_id = '85B73ubBGy';
                    // }
                    if (meta_data.Assignees && (meta_data.Assignees.Contacts?.length || meta_data.Assignees.Roles?.length)) {
                        let contacts = meta_data.Assignees.Contacts ? meta_data.Assignees.Contacts.map(item => item && item.first + ' ' + item.last) : []
                        let roles =  meta_data.Assignees.Roles ? meta_data.Assignees.Roles.map(item => item && item.name) : [];
                        assignees = [...contacts, ...roles].join(', ');
                    } else assignees = 'Everyone'
                    if (association === 'property') {
                        let foundProperty = meta_data.Associations?.property[0];
                        property = (foundProperty.number ? foundProperty.number + ' - ' : '') + (foundProperty.city ? foundProperty.city + ' - ' : '') + foundProperty.name;
                    }
                    if (association === 'space' && this.primaryRoleProperties.find(itemInner => itemInner.id === meta_data.Associations?.space[0].Property.id)) {
                        let foundProperty = this.primaryRoleProperties.find(itemInner => itemInner.id === meta_data.Associations?.space[0].Property.id);
                        property = (foundProperty.number ? foundProperty.number + ' - ' : '') + (foundProperty.city ? foundProperty.city + ' - ' : '') + foundProperty.name;
                    }

                    if (association === 'contact' && this.primaryRoleProperties.find(itemInner => itemInner.id === meta_data.Associations?.lease[0].Property.id)) {
                        let foundProperty = this.primaryRoleProperties.find(itemInner => itemInner.id === meta_data.Associations?.lease[0].Property.id);
                        property = (foundProperty.number ? foundProperty.number + ' - ' : '') + (foundProperty.city ? foundProperty.city + ' - ' : '') + foundProperty.name;
                    }
                    if (meta_data.Attachments.images) attachments.push(meta_data.Attachments.images > 1 ? ' images' : ' image');
                    if (meta_data.Attachments.videos) attachments.push(meta_data.Attachments.videos > 1 ? ' videos' : ' video');
                    if (meta_data.Attachments.attachments) attachments.push(meta_data.Attachments.attachments > 1 ? ' attachments' : ' attachment');
                    if (meta_data.Associations?.lease?.length) {
                        contactData = meta_data.Associations?.lease[0].Tenants
                    }
                    if (meta_data.Associations?.contact?.length) {
                        contactData = meta_data.Associations?.contact[0];
                        association = 'contact';
                    }

                    let labelStatus ='';
                    if (item.status === 'completed') {
                        labelStatus = 'complete';
                    } else if(item.status === 'dismissed') {
                        labelStatus = 'dismissed';
                    } else if(item.is_overdue) {
                        labelStatus = 'overdue';
                    } else if(item.hot_task && !item.is_overdue) {
                        if (this.getTaskColor(item.due_date).color === 'green') {
                            labelStatus = 'timer green';
                        } else {
                            labelStatus = 'timer red';
                        }
                    } else {
                        labelStatus = item.status;
                    }

                    let taskObject = {
                        id: item.id,
                        slug: meta_data.TaskType.slug,
                        lease: association === 'contact' && meta_data.Associations.lease ? meta_data.Associations.lease[0] : null,
                        type: association === 'property' ? 'space' : association,
                        hotTask: item.hot_task ? true : false,
                        icon: meta_data.TaskType.icon,
                        isAutomated: meta_data.TaskType.is_automated ? true : false,
                        title: meta_data.TaskType.slug === 'other' ? item.title : meta_data.TaskType.name,
                        time: item.property_due_date ? item.property_due_date : '',
                        due_date: item.due_date,
                        assignedTo: assignees,
                        createdBy: meta_data.created_by_details && (meta_data.created_by_details.first || meta_data.created_by_details.last) ? meta_data.created_by_details.first + ' ' + meta_data.created_by_details.last : '',
                        createdByTime: item.created_at ? item.created_at : '',
                        updatedBy: meta_data.modified_by_details && (meta_data.modified_by_details.first || meta_data.modified_by_details.last) ? meta_data.modified_by_details.first + ' ' + meta_data.modified_by_details.last : '', 
                        updatedByTime: item.modified_at ? item.modified_at : '',
                        attachments: attachments.length ? attachments.join(', ') : '',
                        space: association === 'space' ? meta_data.Associations?.space[0].unit_number : association === 'contact' && property ? meta_data.Associations?.lease[0]?.Unit.number  : '',
                        spaceType: association === 'contact' && property ? meta_data.Associations?.lease[0]?.Unit.type : association === 'space' ? meta_data.Associations?.space[0].type : '',
                        expanded: false,
                        showLoading: false,
                        contactId: contactData ? contactData.id : '',
                        contactName: contactData ? contactData.first + ' ' + contactData.last : '',
                        contactStatus: contactData? contactData.contact_status : '',
                        contactIsBusiness: contactData?.contact_type == 'Business' ? true : false,
                        property: property,
                        details: item.details,
                        status: item.status,
                        labelStatus,
                        timerGreenValue: !item.is_overdue && item.hot_task && this.getTaskColor(item.due_date).color === 'green' ? this.getTaskColor(item.due_date).text : '',
                        timerRedValue: !item.is_overdue && item.hot_task && this.getTaskColor(item.due_date).color === 'red' ? this.getTaskColor(item.due_date).text : '',
                        is_overdue: item.is_overdue ? true : false,
                        loadingBtnOne: false,
                        loadingBtnTwo: false
                    };
                    if (item.status === 'completed'  || item.status === 'dismissed') {
                        taskObject = {
                            ...taskObject,
                            completedBy: meta_data.status_updated_by_details && (meta_data.status_updated_by_details.first || meta_data.status_updated_by_details.last) ? meta_data.status_updated_by_details.first + ' ' + meta_data.status_updated_by_details.last : '',
                            completedByTime: item.status_updated_at
                        }
                    }
                    return taskObject
                })]
                this.intervalValue = setInterval(() => {
                    this.updateTasksTime();
                }, 1000);
            } catch (error) {
                this.showMessageNotification({type: 'error', description: error});
                this.hasError = true;
            } finally {
                this.isFetchingTasks = false;
            }
        },

        updateTasksTime() {
            let tempTask = this.tasksList.map(item => {
                return {
                    ...item,
                    timerGreenValue: !item.is_overdue && item.hotTask && this.getTaskColor(item.due_date).color === 'green' ? this.getTaskColor(item.due_date).text : '',
                    timerRedValue: !item.is_overdue && item.hotTask && this.getTaskColor(item.due_date).color === 'red' ? this.getTaskColor(item.due_date).text : ''
                }
            });
            this.tasksList = [];
            this.tasksList = tempTask;
        },

        getTaskColor(params) {
            let dbTime = moment.utc(params);
            let currentTime = moment.utc();
            let diffMinutes = currentTime.diff(dbTime, "minutes");
            let diffHours = currentTime.diff(dbTime, "hours");
            let text ='', color = '';
            if (diffHours > 0) {
                text = `${diffHours} hrs ago`;
                color = "red";
            }
            else if(diffMinutes > 5) {
                text = `${diffMinutes} mins`;
                color = "red";
            } else {
                text = `${diffMinutes} mins`;
                color = "green";
            }
            return { text, color };
        },

        closeFilter() {
            this.showFilters = false;
        },
        showTaskDialog() {
            this.closeFilter();
            setTimeout(() => {
                this.showDialog = true;
            }, 20);
        },
        close(exit = true) {
            // if(exit){
            //     this.setTaskCenterOpen(false);
            // }
            this.$emit('close');
        },
        clickedMenu(params) {
            this.activeMenu = params;
        },
        handleClickOutside() {
            if (!this.activeFilter) {
                this.activeMenu = '';
            }
        },
        createTaskShowDialogEvent() {
            this.taskDetails = null;
            this.showDialog = true;
        },
        showFiltered(params) {
            this.activeFilter = null;
            let { parent, child } = params;
            this.$nextTick(() => {
                this.activeFilter = {
                    id: child.id,
                    icon: parent.icon,
                    title: child.name,
                    parent: parent.value,
                    count: this.getTypeCount(child, parent.value)
                }
                this.getTasksAndCountEvent(true);
            });
        },
        clearFilterEvent() {
            this.activeFilter = null;
            this.getTasksAndCountEvent(true);
        },
        async updateTaskEvent(params, isSystem = false) {
            try {
                if (isSystem) params.loadingBtnTwo = true;
                else params.loadingBtnOne = true;
                let response = await api.get(this, api.TASKS_CENTER + params.id);
                let { tasks: task } = response;
                const taskType = Object.values(this.taskTypes).flatMap(item => item).find(itemInner => itemInner.id === task.task_type_id);
                let mediaFiles = [];
                let documents = [];
                let assigness = [...task.Assignees.Contacts.map(item => {
                    return {
                        id: item.id,
                        name: item.first + ' ' + item.last,
                        is_admin: true
                    }
                }), ...task.Assignees.Roles.map(item => {
                    return {
                        id: item.id,
                        name: item.name,
                        is_role: true
                    }
                })];
                if (isSystem) {
                    this.taskDetails = {
                        ...task,
                        assignTo: assigness,
                    }
                    this.showAssignDialog = true;
                    params.loadingBtnTwo = false;
                    return;
                }
                let property = [];
                let association = '';
                if (task.Associations?.lease?.length) association = 'contact';
                else if(task.Associations?.space?.length) association = 'space';
                else if(task.Associations?.property?.length) association = 'property';
                if (association === 'property') {
                    property = task.Associations?.property[0];
                }
                if (association === 'space' && this.primaryRoleProperties.find(itemInner => itemInner.id === task.Associations?.space[0].property_id)) {
                    let foundProperty = this.primaryRoleProperties.find(itemInner => itemInner.id === task.Associations?.space[0].property_id);
                    property = foundProperty;
                }
                if (association === 'contact' && this.primaryRoleProperties.find(itemInner => itemInner.id === task.Associations?.lease[0].Property.id)) {
                    let foundProperty = this.primaryRoleProperties.find(itemInner => itemInner.id === task.Associations?.lease[0].Property.id);
                    property = foundProperty;
                }
                if (task.Associations?.space?.length) {
                    property = this.primaryRoleProperties.find(itemInner => itemInner.id === task.Associations?.space[0].property_id);
                }

                if (task.Attachments?.length) { 
                    for (const element of task.Attachments) {
                        if (element.mimetype.includes('image') || element.mimetype.includes('video')) {
                            let videoThumbnail = '';
                            let isVideo = element.mimetype.includes('video');
                            if (isVideo) {
                                videoThumbnail = await this.createThumbnailFromBase64(element.data_url)
                            }
                            mediaFiles.push({
                                "id": element.id,
                                video: isVideo ? true : false,
                                video_src: `data:${element.mimetype};base64,${element.data_url}`,
                                src: isVideo && videoThumbnail ? videoThumbnail : `data:${element.mimetype};base64,${element.data_url}`,
                                thumbnail: videoThumbnail,
                                upload_id: element.upload_id
                            })
                        } else {
                            documents.push(element)
                        }
                    }
                }
                this.taskDetails = {
                    id: task.id,
                    type: taskType && taskType.label.toLowerCase(),
                    subType: taskType && taskType.id,
                    title: task.title,
                    assignTo: assigness,
                    association: task.Associations?.contact?.length || task.Associations?.lease?.length ? 3 : task.Associations?.space?.length ? 2 : task.Associations?.property?.length ? 1 : 0,
                    selectedProperties: property ? [property] : [],
                    details: task.details,
                    hotTask: task.hot_task ? true : false,
                    dueDate: task.due_date ? task.due_date.split(' ')[0] : '',
                    startDate: task.start_date,
                    mediaFiles,
                    attachments: documents,
                    location: task.task_location === 'inside' ? 0 : 1,
                    associations: task.Associations ? task.Associations : [],
                    status: task.status,
                    createdBy: task.created_by_details
                };
                this.showDialog = true;
            } catch (error) {
                this.showMessageNotification({type: 'error', description: error});
            } finally {
                if (isSystem) params.loadingBtnTwo = false;
                else params.loadingBtnOne = false;
            }
        },
        createThumbnailFromBase64(base64Video) {
            return new Promise((resolve, reject) => {
                const video = document.createElement("video");
                video.src = URL.createObjectURL(new Blob([Uint8Array.from(atob(base64Video), c => c.charCodeAt(0))], { type: "video/mp4" }));
                video.muted = true;
                video.autoplay = true;
                video.playsInline = true;

                video.onloadeddata = () => {
                    const canvas = document.createElement("canvas");
                    canvas.width = 300;
                    canvas.height = (video.videoHeight / video.videoWidth) * 300;
                    canvas.getContext("2d").drawImage(video, 0, 0, canvas.width, canvas.height);
                    resolve(canvas.toDataURL("image/png"));
                };

                video.onerror = () => reject("Error loading video");
            });
        },
        assignClick() {
            this.showAssignDialog = true;
        },
        async fetchAssignees(){
            let usersRequest = api.get(this, api.ADMIN + 'active/users');
            let rolesRequest = api.get(this, api.ROLES);
            Promise.all([usersRequest, rolesRequest])
            .then(responses => {
                this.taskAssignees = [...responses[0].admins.map( item => { 
                    return {
                        id: item.contact_id,
                        name: item.first + ' ' + item.last,
                        is_admin: true
                    }
                }), ...responses[1].roles.map( item => {
                    return {
                        id: item.id,
                        name: item.name,
                        is_role: true
                    }
                })];
            })
        },
        async showDetailsEvent(params){
            let { slug, lease } = params;
            params.showLoading = true;
            if(params.status == 'pending'){
                if (slug === 'pending_transfer') {            
                    EventBus.$emit('HB-Navigation:TaskCenter-New', false);
                    await this.$store.dispatch('onBoardingStore/getPropertyInfo', this.primaryRoleProperties.find(p => p.id === lease.Property.id));
                    await this.$store.dispatch('onBoardingStore/getPending', { unit_id: lease.Unit.id });
                    let data = {
                        lease_id: lease.Transfer.from_lease_id,
                        contact: {id: lease.Tenants.id},
                        unit_id: lease.Unit.id,
                        transfer: lease.Transfer,
                        property_id: lease.Property.id
                    };
                    EventBus.$emit('transfer', data);
                } 
                else if (slug === 'pending_move_in') {
                    EventBus.$emit('HB-Navigation:TaskCenter-New', false);
                    this.actionFollowUpStatus(true);
                    await this.$store.dispatch('onBoardingStore/getPropertyInfo', this.primaryRoleProperties.find(p => p.id === lease.Property.id));
                    await this.$store.dispatch('onBoardingStore/getPending', { unit_id: lease.Unit.id });
                    EventBus.$emit('new_lead');
                    // this.setTaskCenterOpen(false);
                } 
                else if (['task', 'task_followup', 'marketing_automation_create_task', 'task_care_call', 'task_first_Call','other','lock_removal','overlock_space','lock_cut','clean_&_prepare_space'].includes(slug))  {
                    // this.complete();
                    let response = await api.get(this, api.TASKS_CENTER + params.id);
                    let { tasks: task } = response;
                    if (task.Attachments?.length) {
                        task.mediaFiles = [];
                        for (const element of task.Attachments) {
                            if (element.mimetype.includes('image') || element.mimetype.includes('video')) {
                                let videoThumbnail = '';
                                let isVideo = element.mimetype.includes('video');
                                if (isVideo) {
                                    videoThumbnail = await this.createThumbnailFromBase64(element.data_url)
                                }
                                task.mediaFiles.push({
                                    "id": element.id,
                                    video: isVideo ? true : false,
                                    video_src: `data:${element.mimetype};base64,${element.data_url}`,
                                    src: isVideo && videoThumbnail ? videoThumbnail : `data:${element.mimetype};base64,${element.data_url}`,
                                    thumbnail: videoThumbnail,
                                    upload_id: element.upload_id
                                })
                            }
                        }
                    }
                    task = {
                        ...task,
                        is_overdue: params.is_overdue
                    }
                    this.singleTaskData = task;
                    this.showDetailsDialog = true;
                } 
                else {
                    switch (slug) {
                        case 'new_lead'             :
                        case 'new_web_lead'         :
                        case 'cart_abandonment'     :
                        case 'coupon_clicks'        :
                        case 'hotlead'              :
                        case 'reservation_failure'  :
                        case 'lead_follow_up'       :
                        case 'new_reservation'      :
                        case 'new_web_reservation'  :
                        case 'reservation_follow_up':
                            if (slug === 'new_web_lead' || slug === 'new_web_reservation' || slug === 'new_reservation' || slug === 'new_lead' || slug === 'cart_abandonment' || slug === 'coupon_clicks' || slug === 'reservation_failure' || slug === 'hotlead') {
                                let event = {
                                    id: params.id,
                                    time: params.createdByTime
                                }   
                                this.fetchData(event, params.contactId, lease);
                            } else {
                                this.fetchData(null, params.contactId, lease);
                            }
                            break;
                        case 'collection_calls':
                            let contactData = {...lease.Tenants, Phones: []};
                            let taskData = params;
                            contactData.lease_id = lease.id;
                            contactData.property_id =  lease.Property.id; 
                            let allData = { ...contactData, ...taskData };
                            EventBus.$emit('HB-Navigation:DelinquencyCenter', allData);
                            break;
                        case 'move_out':
                        case 'move_out_cancelled':
                        case 'move_out_confirmation':
                            let data = {
                                property_id: lease.Property.id,
                                lease_id: lease.id,
                                contact: {...lease.Tenants, Phones: []},
                                unit_id:  lease.Unit.id,
                                move_out_date: params.createdByTime
                            };
                            EventBus.$emit('move_out', data);
                            break;
                        case 'review_rate_change_notification':
                        case 'approve_rate_change':
                            let rateData = {
                                rateChangeType: params.Rate_Change.reviewed ? 'finalize-rate-change' : 'review-rate-change',
                                rateChangeItem : params.Rate_Change,
                            }
                            EventBus.$emit('rate_change', rateData);
                            break;
                        case 'move_out':
                        case 'auction_day':
                        case 'auction_payment':
                            EventBus.$emit('HB-Navigation:AuctionManager', lease, lease.Tenants.id, 3);
                            break;
                        case 'cut_lock_schedule_auction': 
                            EventBus.$emit('HB-Navigation:AuctionManager', lease, lease.Tenants.id, 0);
                            break;
                        case 'auction_notice_advertisement':
                        case 'space_inventory':
                            // this.complete();
                            EventBus.$emit('HB-Navigation:AuctionManager', lease, lease.Tenants.id, 1);
                            break;
                        // case 'lock_cut':
                        //     this.complete();
                        //     break;
                        case 'generated_rate_change_documents':
                            EventBus.$emit('download_center')
                            break
                        default:
                            break;
                    }
                }
            }
            params.showLoading = false;
        },

        fetchData(event = null, contact_id, lease = null){
            
            api.get(this, api.CONTACTS + contact_id).then(r => {
                var contact = r.contact;
                var data = {
                    contact_id: contact.id,
                    lead_first: contact.first,
                    lead_last: contact.last
                }

                if(contact.Lead){
                    data.lead_time = contact.Lead.created;
                    data.id = contact.Lead.id;
                }

                if(lease?.Unit && contact.Reservations){
                    contact.Reservations.forEach( reservation => {
                        if (reservation.Lease && reservation.Lease.Unit && reservation.Lease.Unit.id == lease.Unit.id) {
                            data.expires = reservation.expires;
                            data.lease_id = reservation.Lease.id;
                            data.reservation_id = reservation.id;
                            data.reservation_time = reservation.created;
                            data.unit_id = reservation.Lease.Unit.id;
                            data.property_id = reservation.Lease.Unit.property_id
                        }
                    });
                }
                data.event = event;
                data.selectedLeadId = lease?.Lead ? lease.Lead.id : '';
                // setting follow up status to true as the lead is being followed up from task center 
                this.actionFollowUpStatus(true)
                EventBus.$emit('HB-Navigation:LeadFollowUp', data);
            });
        },
        clearFiltersEvent() {
            this.filtersData = {};
            this.selectedFilter = {id: 'due_today', name: 'Due Today'};
            this.getTasksAndCountEvent(true);
        },
        fetchOnScroll ({ target: { scrollTop, clientHeight, scrollHeight }}) {
            if (Math.ceil(scrollTop + clientHeight) >= scrollHeight) {
                if ((this.tasksList.length%20) === 0 && !this.isLoading(this.$options.name) && !this.isAllRecordsLoaded) {
                    this.getTasksAndCountEvent(false, false)
                }
            }
        },
        setFiltersEvent(params, isReset = false) {
            this.filtersData = {...this.filtersData, ...params};
            if (isReset) this.selectedFilter = {id: 'due_today', name: 'Due Today'};
            this.getTasksAndCountEvent(true, true, isReset ? false : true);
            this.showFilterDialog = false;
        },
        getTasksAndCountEvent(resetTasks = false, getCounts = true, resetMainFilter = false) {
            this.fetchTasks(resetTasks, resetMainFilter);
            if(getCounts) this.fetchTasksCount();
            this.setTasksHotTotalCount();
        },
        getFilters(isCount = false, resetTasks = false, resetMainFilter = false) {
            let associate;
            switch (this.filtersData.association) {
                case 1:
                    associate = 'property'
                    break;
                case 2:
                    associate = 'space'
                    break;
                case 3:
                    associate = 'lease'
                    break;
                default:
                    associate = ''
                    break;
            }
            let statuses = [];
            if (resetMainFilter) this.selectedFilter = {id: '', name: 'All Tasks'};
            if(this.selectedFilter.id) statuses = [this.selectedFilter.id];
            if (this.filtersData.statuses && this.filtersData.statuses.length) statuses = [...statuses, ...this.filtersData.statuses];
            let filterPayload = {
                task_labels: [
                    "Delinquency",
                    "Lead",
                    "Operations",
                    "Maintenance"
                ],
                statuses,
                ...(this.filtersData.assignees?.length && { assigned_to: this.filtersData.assignees.filter(item => item && item.id).map(item => { 
                        return {
                            type: item.is_role ? 'role' : 'user',
                            id: item.id
                        }
                    })
                }),
                ...(associate && (this.filtersData.associations?.length || this.filtersData.selectedProperties?.length) && { associated_with: this.filtersData[associate === 'property' ? 'selectedProperties' : 'associations'].filter(item => item && item.id).map(item => { 
                        return {
                            type: associate,
                            id: associate === 'lease' ? item.lease_id : item.id
                        }
                    })
                }),
                ...(this.filtersData.createdByList?.length && { created_by_ids: this.filtersData.createdByList.map(item => { 
                        return {
                            id: item.id
                        }
                    })
                }),
                ...(this.filtersData.types?.length && { task_type_ids: this.filtersData.types.map(item => { 
                        return {
                            id: item
                        }
                    })
                }),
                ...(this.filtersData?.created_from && { created_from: this.filtersData?.created_from }),
                ...(this.filtersData?.created_to && { created_to: this.filtersData?.created_to }),
                ...(this.filtersData?.due_date_from && { due_date_from: this.filtersData?.due_date_from }),
                ...(this.filtersData?.due_date_to && { due_date_to: this.filtersData?.due_date_to }),
            }
            if (this.activeFilter) {
                if (this.activeFilter.title === 'All Tasks') {
                    let bucketTypes = this.taskTypes[this.activeFilter.parent].filter(item => item && item.id).map(item => item.id);
                    let selectedTypes = this.filtersData.types ? this.filtersData.types.filter(item => bucketTypes.includes(item)) : [];
                    if (selectedTypes.length) {
                        filterPayload.task_type_ids = [...filterPayload.task_type_ids, ...bucketTypes.filter(item => !selectedTypes.includes(item)).map(item => { return { id: item }})]
                    } else {
                        filterPayload.task_type_ids = filterPayload.task_type_ids ? [...filterPayload.task_type_ids, ...bucketTypes.map(item => { return { id: item }})] : bucketTypes.map(item => { return { id: item }});
                    }
                } else {
                    filterPayload = {
                        ...filterPayload,
                        task_type_ids: this.filtersData.types?.length ? [...[{ id: this.activeFilter.id }], ...this.filtersData.types.map(item => { 
                            return {
                                id: item
                            }
                        })] : [{ id: this.activeFilter.id }]
                    }
                }
            }
            let types = Object.values(this.taskTypes).flatMap(item => item).filter(item => item.id);
            if (!filterPayload.task_type_ids?.length) {
                filterPayload = {
                    ...filterPayload,
                    task_type_ids: types.map(item => { return { id: item.id}})
                }
            }
            if (!isCount) {
                if (resetTasks) {
                    this.tasksList = [];
                }
                filterPayload = {
                    ...filterPayload,
                    limit: 20, 
                    offset: this.tasksList.length
                }
            }
            let filterKeys = Object.keys(filterPayload).filter(item => !['task_labels', 'limit','offset'].includes(item));
            let count = filterKeys.length;
            if (this.activeFilter && !this.filtersData.types?.length) {
                count -= 1;
            }
            if (types.length === filterPayload.task_type_ids.length) {
                count -= 1;
            }
            if (!this.filtersData.statuses?.length) {
                count -= 1;
            }
            if (filterKeys.filter(item => ['created_from','created_to'].includes(item)).length === 2) {
                count -= 1;
            }

            if (filterKeys.filter(item => ['due_date_from','due_date_to'].includes(item)).length === 2) {
                count -= 1;
            }
            this.filtersCount = count;
            return filterPayload;
        }
    },
    components: {
        'hb-task': () => import('../../../aviary/HbTask.vue'),
        'create-task': () => import('./CreateTask.vue'),
        'tasks-filter': () => import('./TaskFilterModal.vue'),
        'update-system-task': () => import('./UpdateSystemTask.vue'),
        'task-details': () => import('./TaskDetails.vue'),
        'async-loader': () => import('../../includes/Loading.vue')
    },
    watch: {
        // activeView(value){
        //     if (value !== 'view') {
        //         if (value === 'moveIn') {
        //             this.fetchPending();
        //         }
        //         else if (value !== 'seeList') {
        //             this.getTasks();
        //         }
        //     } else {
        //         this.tempTask = [];
        //         this.resetTasks();
        //     }
        // },
        // eventTypes(value) {
        //     if (value) {
        //    //     this.setIds();
        //     }
        // }
    },
    destroyed() {
        // this.resetTasks();
        clearInterval(this.intervalValue);
        EventBus.$off('hide_drawer', this.close);
    },
}
</script>
<style lang="scss">
@media (max-width: 600px) {
    .task-center-panel {
        .hb-blade-header-wrapper {
            .hb-blade-header-card-wrapper {
                .hb-blade-header-wrapper-title div {
                    display: flex !important;
                    flex: unset !important;
                }

                div:nth-child(1) {
                    padding-left: 0px;
                    justify-content: flex-start !important;
                    position: relative;
                    left: 5px;
                    flex: 2 0 70%;
                    max-width: 100%;
                }
            }
        }
    }
}
</style>
<style scoped lang="scss">
.bs-none {
    box-shadow: none !important;
}

.tasks-counter {
    background-color: #F26500;

    >div {
        font-style: normal;
        font-weight: 500;
        font-size: 28px;
        line-height: 14px;
        color: #fff;

        small {
            font-style: normal;
            font-size: 10px;
            line-height: 16px;
            font-weight: 500;
        }
    }
}

.task-calender {
    font-weight: 500;
    font-size: 20px;
    line-height: 24px;
    color: #101318;
}

.pad-10px {
    // padding-left: 13px;
    // padding-right: 13px;
    padding-top: 10px;
    // padding-bottom: 8px;
}

.task-btns {
    .task-btn-icon {
        padding: 10px 10px 7px 10px;
        display: inline-block;
    }
}

.task-bucket {
    width: 89px;
    height: 89px;
    padding: 8px;
    gap: 5px;
    border-radius: 8px;
    border: 1px solid #DFE3E8;
    background: #FFFFFF;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    &.bucket-active {
        border: 2px solid #00848E;
    }

    .bucket-icon {
        padding: 8px;
        border-radius: 20px;
        background: #F4F6F8;
        position: relative;

        &:focus {
            background-color: #F26500;
        }

        .tasks-counter {
            padding: 1px 7px;
            border-radius: 20px;
            background: #F26500;
            color: #FFFFFF;
            font-size: 10px;
            font-weight: 500;
            text-align: center;
            position: absolute;
            top: 0;
            right: 0;
        }
    }
}

.menu-task-count {
    border-radius: 20px;
    background: #F26500;
    color: #FFFFFF;
    font-size: 10px;
    font-weight: 500;
    text-align: center;
    display: inline-block;
    line-height: 15px;
    position: absolute;
    right: 12px;
    padding: 1px 7px;
}

.tasks-counter-filter {
    padding: 1px 7px;
    border-radius: 20px;
    background: #F26500;
    color: #FFFFFF;
    font-size: 10px;
    font-weight: 500;
    text-align: center;
    top: 0;
    right: 0;
}

.filter-title {
    display: flex;
    align-items: center;
}

.clear-filter-btn {
    background: #DFE3E8;
    color: #637381;
    border-radius: 4px;
    padding: 1px 5px;
}

.filter-icon {
    position: relative;
    top: 8px;

    &.active-filter {
        background-color: #E0F5F5;
        border-radius: 50%;
    }

    .filter-count {
        padding: 1px 7px;
        border-radius: 20px;
        background: #F26500;
        color: #FFFFFF;
        font-size: 10px;
        font-weight: 500;
        text-align: center;
        position: absolute;
        top: 0;
        right: 0;
    }
}

.empty-complete {
    text-align: center;
    padding-top: 100px;

    .complete-text {
        font-weight: 500;
        font-size: 18px;
        line-height: 32px;
        color: #A5B4BF;
        padding-top: 12px;
        padding-bottom: 20px;
    }
}

</style>
